import React, { useState } from "react";
import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { Stack, Button } from "@mui/material";
import { isEmptyObject } from "helpers/formatObject";
import {
  NewDialog,
  MuiFormBuilder,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function Create({ refetch, title = "جدید" }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [create, { loading }] = useMutation(graph.create.query, {
    context: {
      serviceName: graph.create.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await create({
        variables: {
          ...formData,
          status_id: '1', type_id: '2', role_id: '12'
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.create.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <Button size="medium" color="warning" variant="outlined" onClick={onOpen}>
        {title}
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            <MuiFormBuilder
              id="submit"
              showSubmit={false}
              liveValidate={false}
              schema={schema()}
              uiSchema={uiSchema()}
              formData={formData}
              onSubmit={onSubmit}
            />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="submit"
            variant="contained"
            disabled={loading}
          >
            {title}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
